/**
 * @voltxampere/ui — Waveform grid (Sprint 15)
 *
 * Two-axis dotted grid: 10 horizontal × 8 vertical divisions
 * (the analogue scope custom). The dots sit on division
 * intersections; the major divisions get a subtle solid line so
 * eyeballing amplitude against a marker is easy.
 *
 * Zenit voice: theme.text.faint dots, theme.text.wisp gridlines.
 *
 * Copyright © 2026 360 Studio
 * Proprietary — All rights reserved.
 */
import { TIME_DIVISION_COUNT, V_DIVISION_COUNT } from "../types.js";
export function drawWaveformGrid(ctx, theme, opts) {
    const { canvasWidth, canvasHeight } = opts;
    const tCount = opts.timeDivCount ?? TIME_DIVISION_COUNT;
    const vCount = opts.voltageDivCount ?? V_DIVISION_COUNT;
    ctx.save();
    ctx.strokeStyle = theme.text.wisp;
    ctx.lineWidth = 1;
    ctx.lineCap = "square";
    // Outer frame.
    ctx.beginPath();
    ctx.rect(0.5, 0.5, canvasWidth - 1, canvasHeight - 1);
    ctx.stroke();
    // Horizontal division lines (V/div boundaries).
    for (let i = 1; i < vCount; i++) {
        const y = (i / vCount) * canvasHeight;
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(canvasWidth, y);
        ctx.stroke();
    }
    // Vertical division lines (time/div boundaries).
    for (let i = 1; i < tCount; i++) {
        const x = (i / tCount) * canvasWidth;
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, canvasHeight);
        ctx.stroke();
    }
    // Centre crosshair — major axes drawn brighter.
    ctx.strokeStyle = theme.text.faint;
    ctx.beginPath();
    ctx.moveTo(canvasWidth / 2, 0);
    ctx.lineTo(canvasWidth / 2, canvasHeight);
    ctx.moveTo(0, canvasHeight / 2);
    ctx.lineTo(canvasWidth, canvasHeight / 2);
    ctx.stroke();
    ctx.restore();
}
//# sourceMappingURL=grid.js.map